// extracted by mini-css-extract-plugin
module.exports = {"container":"_3PN8v","description":"_3bxy9","checkboxContainer":"_2jsm6","alert":"_1qlEX","policy":"_3ku8o","sectionNotificationContainer":"_3CJ_I","labelContainer":"_27Qf7"};